
	export default {
		name: "PrivacyPolicyText",
	};
